var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
import { BrandRenderLayout } from "../../brand/steps/brand-render-layout";
import { BrandRenderTheme } from "../../brand/steps/brand-render-theme";
import { SyndicateKeyHelper } from "../../../../../services/modules/brand-client.service";
// Render-engine editor scoped to a single syndicate: a 3-pane (Structure + Preview + Style) dialog reusing
// the brand layout/theme editors, locked to the Syndicate page. Replaces the legacy SyndicateBrandingDialog.
var SyndicateRenderDialog = /** @class */ (function () {
    function SyndicateRenderDialog(dialogClientService, i18N, notificationService, layout, theme) {
        var _this = this;
        this.dialogClientService = dialogClientService;
        this.i18N = i18N;
        this.layout = layout;
        this.theme = theme;
        this.selectedSection = null;
        // Inline text-edit mode: threads to the shared preview so the syndicate page's text can be clicked and
        // edited in place, then written to the theme's current-language tokens.
        this.editText = false;
        this.previewBrandId = null;
        this.previewTemplateName = null;
        this.previewThemeName = null;
        this.previewSyndicateId = null;
        this.previewSyndicateKey = null;
        this.previewSyndicateBrandLotteryId = null;
        // True while a right-panel click drives the left selection, so the round-trip doesn't reopen the group.
        this.syncingFromTheme = false;
        this.layout.embeddedPreview = false;
        this.theme.embeddedPreview = false;
        this.layout.onSelect = function (section) { return _this.onLayoutSelect(section); };
        this.theme.onSelectVariant = function (variantId) { return _this.onThemeSelectVariant(variantId); };
        // The Style panel reads placement live from the layout panel and refreshes its colour groups when
        // a section is added/removed there.
        this.theme.layoutSectionsProvider = function () { return _this.layout.layout ? _this.layout.layout.sections : null; };
        this.layout.onLayoutChanged = function () { return _this.theme.refreshColorSections(); };
    }
    SyndicateRenderDialog.prototype.activate = function (model) {
        var e_1, _a, e_2, _b;
        this.item = model;
        var nav = model.navigationInfo || {};
        // Both child editors read item only in brand mode; a minimal adapter keeps any HTML bindings safe.
        this.adapterItem = { brandId: nav.brandId, activeBrandLotteries: nav.brandLotteries || [], brandLanguages: nav.brandLanguages || [] };
        // "Copy from another syndicate": the brand's other syndicates, gathered from its lotteries and
        // deduped by id (a syndicate can hang off several lotteries), excluding this one.
        this.theme.itemKeyPrefix = SyndicateKeyHelper.getKey(model.name);
        var seenSyndicate = {};
        var syndicateCandidates = [];
        try {
            for (var _c = __values((nav.brandLotteries || [])), _d = _c.next(); !_d.done; _d = _c.next()) {
                var bl = _d.value;
                try {
                    for (var _e = (e_2 = void 0, __values((bl.syndicates || []))), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var s = _f.value;
                        if (!s.syndicateId || s.syndicateId === model.syndicateId || seenSyndicate[s.syndicateId])
                            continue;
                        seenSyndicate[s.syndicateId] = true;
                        var name_1 = s.name || ("#" + s.syndicateId);
                        syndicateCandidates.push({ key: "s" + s.syndicateId, label: name_1, keyPrefix: SyndicateKeyHelper.getKey(name_1), syndicateId: s.syndicateId });
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.theme.copyCandidates = syndicateCandidates;
        // Scope both panes to this syndicate. Set before the view composes the children (their onActivated
        // reads these), and supply brand/template directly since the model is a SyndicateModel.
        this.layout.syndicateId = this.theme.syndicateId = model.syndicateId;
        this.layout.overrideBrandId = this.theme.overrideBrandId = nav.brandId;
        this.layout.overrideTemplateName = this.theme.overrideTemplateName = nav.brandTemplateInternalName;
        // Centre preview targets this syndicate's ID-backed page.
        this.previewBrandId = nav.brandId;
        this.previewTemplateName = nav.brandTemplateInternalName;
        this.previewThemeName = nav.brandThemeInternalName;
        this.previewSyndicateId = model.syndicateId;
        this.previewSyndicateBrandLotteryId = model.brandLotteryId;
        this.previewSyndicateKey = SyndicateKeyHelper.getKey(model.name);
    };
    SyndicateRenderDialog.prototype.attached = function () {
        // Both embedded editors share this one preview for highlight + reload-on-save.
        this.layout.preview = this.preview;
        this.theme.preview = this.preview;
    };
    SyndicateRenderDialog.prototype.onLayoutSelect = function (section) {
        this.selectedSection = section;
        if (this.theme && section && !this.syncingFromTheme)
            this.theme.openColorSection(section);
    };
    SyndicateRenderDialog.prototype.onThemeSelectVariant = function (variantId) {
        this.syncingFromTheme = true;
        this.layout.selectByVariant(variantId);
        this.syncingFromTheme = false;
    };
    Object.defineProperty(SyndicateRenderDialog.prototype, "selectedSectionLabel", {
        get: function () {
            return this.selectedSection ? this.layout.variantLabel(this.selectedSection) : null;
        },
        enumerable: false,
        configurable: true
    });
    // An inline edit was committed in the preview: write it to the theme's current-language text tokens.
    SyndicateRenderDialog.prototype.onTextEdit = function (key, value) {
        if (this.theme)
            this.theme.applyInlineText(key, value);
    };
    SyndicateRenderDialog.prototype.close = function () {
        this.dialogClientService.hide();
    };
    SyndicateRenderDialog = __decorate([
        autoinject,
        __metadata("design:paramtypes", [DialogClientService,
            I18N,
            NotificationClientService,
            BrandRenderLayout,
            BrandRenderTheme])
    ], SyndicateRenderDialog);
    return SyndicateRenderDialog;
}());
export { SyndicateRenderDialog };
